const Seniors = ({size, color}) => {
    return (  
        <>
            <svg 
                fill={color} 
                height={size} 
                width={size} 
                version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 449.358 449.358" xmlSpace="preserve"
            >
            <g>
                <path d="M301.94,102.856c22.987,0,41.613-18.628,41.613-41.613c0-22.986-18.626-41.613-41.613-41.613
                    c-22.988,0-41.614,18.627-41.614,41.613C260.327,84.228,278.952,102.856,301.94,102.856z"/>
                <path d="M111.319,102.856c22.986,0,41.612-18.628,41.612-41.613c0-22.986-18.626-41.613-41.612-41.613
                    c-22.988,0-41.614,18.627-41.614,41.613C69.705,84.228,88.331,102.856,111.319,102.856z"/>
                <path d="M430.84,237.059c1.314-5.792-0.644-12.088-5.595-16.046l-37.676-30.12l-34.865-84.748
                    c-2.13-5.178-6.667-8.623-11.782-9.606c-9.633,10.629-23.541,17.317-38.982,17.317c-15.441,0-29.349-6.688-38.983-17.317
                    c-5.117,0.982-9.656,4.427-11.787,9.606l-44.544,108.277l-44.544-108.277c-2.13-5.178-6.666-8.624-11.782-9.606
                    c-9.633,10.63-23.541,17.317-38.982,17.317c-15.441,0-29.349-6.688-38.983-17.317c-5.118,0.982-9.657,4.427-11.788,9.606
                    L1.207,250.389c-3.362,8.172,0.538,17.523,8.71,20.884c1.992,0.819,4.053,1.207,6.082,1.207c6.292,0,12.26-3.737,14.803-9.917
                    l30.068-73.09v20.243l-29.849,93.252c-5.02,15.683,6.68,31.713,23.146,31.713h6.702v73.99c0,11.883,9.846,21.467,21.824,21.041
                    c11.409-0.406,20.286-10.129,20.286-21.546v-73.485h16.671v73.99c0,11.883,9.844,21.466,21.822,21.041
                    c11.41-0.405,20.288-10.13,20.288-21.547v-73.484h6.702c16.467,0,28.167-16.03,23.146-31.713l-29.849-93.252v-20.244l24.062,58.492
                    c3.47,8.436,11.69,13.943,20.812,13.943h0c9.124,0,17.345-5.509,20.814-13.948l24.042-58.486v219.199
                    c0,11.883,9.845,21.467,21.824,21.041c11.409-0.406,20.287-10.129,20.287-21.546V294.542c0-4.44,3.35-8.316,7.781-8.603
                    c4.855-0.314,8.889,3.53,8.889,8.317v114.418c0,11.883,9.845,21.467,21.823,21.041c11.41-0.406,20.287-10.13,20.287-21.547V189.474
                    l7.166,17.419c1.033,2.51,2.687,4.716,4.807,6.411l38.057,30.425c-4.899,4.959-7.93,11.767-7.93,19.271v158.417
                    c0,4.073,3.138,7.624,7.209,7.746c4.212,0.126,7.667-3.251,7.667-7.435v-158.36c0-6.537,4.842-12.26,11.35-12.873
                    c7.469-0.704,13.773,5.178,13.773,12.504v18.697c0,4.073,3.138,7.624,7.209,7.746c4.212,0.126,7.667-3.251,7.667-7.434V263
                    C449.358,250.993,441.602,240.77,430.84,237.059z"/>
            </g>
            </svg>
        </>
    );
}
 
export default Seniors;